import React from "react";

const GridSix = () => {
    return(
        <div className="item-six">
                <div className="myContent-two">
                <h1>Photography</h1>
                <p>Increase your credibility by getting the most stunning, high-quality photos that improve your business image.</p>
            </div>
        </div>
    )
}

export default GridSix;